export const publishArea = [
  '',
  `mutation publishArea($id:Int!) {
    publishArea(id:$id)
  }
`,
  'publishArea'];
